import { render, staticRenderFns } from "./ButtonDelete.vue?vue&type=template&id=047b9b46"
import script from "./ButtonDelete.vue?vue&type=script&lang=ts"
export * from "./ButtonDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports